module.exports = __webpack_public_path__ + "static/media/LOGO_DISEX2.02a94e15.png";